export const getFilename = (header) => {
    const regex = new RegExp(`${'filename="'}(.*?)${'"'}`);
    const matches = header.get('Content-Disposition').match(regex);

    return matches[1].trim();
};
